import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { ModelType } from "@/gql/graphql";
import { useTranslations } from "use-intl";

export function ActivityLogDialog({
  modelId,
  modelType,
}: {
  modelId: string;
  modelType: ModelType;
}) {
  const t = useTranslations("activityLog.dialog");

  return (
    <BaseDialog title={t("title")}>
      <ActivityLogFeed modelId={modelId} modelType={modelType} />
    </BaseDialog>
  );
}
